import useRouter from 'hooks/useRouter';
import ChargeDriverDetailView from '../../components/ChargeDriverDetailView';

ChargeDriverDetailScreen.propTypes = {};

function ChargeDriverDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const driverId = router.query?.chargeDriverId;

  return <ChargeDriverDetailView driverId={driverId} />;
}

export default ChargeDriverDetailScreen;
